import {
  OffChainTriggerAdvancedFilter,
  OffChainTriggerAdvancedFilterType,
  OnChainTriggerAdvancedFilter,
  OnChainTriggerAdvancedFilterType,
  TriggerConditionComparatorToLabelMap,
  UintArgumentUnitType,
} from '../domain';

export const INITIAL_TRIGGER_FILTER_FORM_VALUES: OnChainTriggerAdvancedFilter = {
  argument: '',
  operator: '',
  value: '',
  type: 'address',
  unit: UintArgumentUnitType.Ether,
};

export const INITIAL_OFF_CHAIN_TRIGGER_FILTER_FORM_VALUES: OffChainTriggerAdvancedFilter = {
  argument: '',
  operator: '',
  value: '',
  type: '' as OffChainTriggerAdvancedFilterType,
};

export const triggerComparatorsToLabelMap: TriggerConditionComparatorToLabelMap = {
  '==': 'is equal to',
  '!=': 'is not equal to',
  '>': 'is greater than',
  '<': 'is lower than',
  '<=': 'is lower than or equal to',
  '>=': 'is greater than or equal to',
  contains: 'contains',
  notContains: 'does not contain',
};

const equalityComparators = [
  {
    value: '==',
    label: 'is equal to',
  },
  {
    value: '!=',
    label: 'is not equal to',
  },
];

const numericComparators = [
  {
    value: '>',
    label: 'is greater than',
  },
  {
    value: '<',
    label: 'is lower than',
  },
  {
    value: '<=',
    label: 'is lower than or equal to',
  },
  {
    value: '>=',
    label: 'is greater than or equal to',
  },
];

interface IOperatorOption {
  type: OnChainTriggerAdvancedFilterType | 'int';
  options: { value: string; label: string }[];
}

export const operatorOptions: IOperatorOption[] = [
  {
    type: 'address',
    options: [...equalityComparators],
  },
  {
    type: 'uint',
    options: [...equalityComparators, ...numericComparators],
  },
  {
    type: 'int',
    options: [...equalityComparators, ...numericComparators],
  },
  {
    type: 'string',
    options: [
      ...equalityComparators,
      {
        value: 'contains',
        label: 'contains',
      },
      {
        value: 'notContains',
        label: 'does not contain',
      },
    ],
  },
  {
    type: 'bytes',
    options: [...equalityComparators],
  },
  {
    type: 'bool',
    options: [...equalityComparators],
  },
];

export const offChainTriggerArgumentTypes: {
  value: OffChainTriggerAdvancedFilterType;
  label: string;
}[] = [
  {
    value: 'string',
    label: 'String',
  },
  {
    value: 'int',
    label: 'Integer',
  },
  {
    value: 'boolean',
    label: 'Boolean',
  },
];
